import { Box, Button, Text } from '@youversion/design-system-components';
import BankStroked from '@youversion/design-system-icons/lib/BankStroked';
import ChevronRightStroked from '@youversion/design-system-icons/lib/ChevronRightStroked';
import { AmericanExpress, Discover, MasterCard, Visa } from 'components/images';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { firebaseLogEvent } from 'utils/firebase';

interface PaymentMethodsAddProps {
  onAddBank: () => void;
  onAddCard: () => void;
}

export default function PaymentMethodsAdd({ onAddCard, onAddBank }: PaymentMethodsAddProps) {
  const { t } = useTranslation('common');

  return (
    <Box className='grid gap-2'>
      <Button
        className='block max-w-none py-2 px-2 dark:bg-canvas-secondary-dark rounded-1 bg-white'
        data-testid='add-bank-account'
        onClick={() => {
          firebaseLogEvent('GivingButtonTap', { label: 'Bank Account', screen: 'giving_add_payment_method' });
          onAddBank();
        }}
      >
        <Box className='flex items-center justify-between'>
          <Text size='lg' variant='buttonLabel'>
            {t('giving.titles.bank_account')}
          </Text>
          <Box className='flex justify-enditems-center'>
            <BankStroked className='dark:text-text-dark' width={32} />
            <ChevronRightStroked className='mis-2 text-text-light dark:text-text-dark rtl:rotate-180' />
          </Box>
        </Box>
      </Button>
      <Button
        className='block max-w-none py-2 px-2 dark:bg-canvas-secondary-dark rounded-1 bg-white'
        data-testid='add-credit-card'
        onClick={() => {
          firebaseLogEvent('GivingButtonTap', { label: 'Card', screen: 'giving_add_payment_method' });
          onAddCard();
        }}
      >
        <Box className='flex items-center justify-between'>
          <Text size='lg' variant='buttonLabel'>
            {t('giving.titles.card')}
          </Text>
          <Box className='flex items-center'>
            <Box className='grid gap-1 grid-cols-4'>
              <Discover width={32} />
              <Visa width={32} />
              <MasterCard width={32} />
              <AmericanExpress width={32} />
            </Box>
            <ChevronRightStroked className='mis-2 text-text-light dark:text-text-dark rtl:rotate-180' />
          </Box>
        </Box>
      </Button>
    </Box>
  );
}
